(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shop-the-stacks"] && !Shopify.designMode) return;
  try {
    
  class ShopTheStack extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll('.shop-the-stack__tab');
      this.cards = this.querySelectorAll('.shop-the-stack__card');

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.filterByTab(tab));
      });
    }

    filterByTab(activeTab) {
      const filter = activeTab.dataset.tabFilter;

      this.tabs.forEach((tab) =>
        tab.classList.toggle('active', tab === activeTab)
      );

      this.cards.forEach((card) => {
        if (filter === 'all') {
          card.hidden = false;
          return;
        }

        const cardTabs = card.dataset.cardTabs
          .split(',')
          .map((t) => t.trim())
          .filter(Boolean);

        card.hidden = !cardTabs.includes(filter);
      });
    }
  }

  customElements.define('shop-the-stack', ShopTheStack);

  } catch(e) { console.error(e); }
})();
})();
